import { Component, OnInit } from '@angular/core';

/*
 * Add Lab Dialog
 */
@Component({
    selector: 'app-add-lab',
    templateUrl: 'add-lab-dialog.html',
    styleUrls: ['./add-lab-dialog.scss']
  })
  export class DialogAddLabComponent implements OnInit  {
    constructor() {
      // constructor
    }
  
    ngOnInit(): void {  
      // ngOnInit
    }
  }